export default {
    baseStyle: {
        gcNotAvailableContainer: {
            padding: '56px 10px',
            bg: 'lightBeige',
            textAlign: 'center'
        },
        formsContainer: {
            padding: '56px 10px',
            bg: 'lightBeige',
            gap: '10px',
            flexDirection: ['column', 'column', 'row', 'row'],
            justifyContent: 'center',
            alignItems: ['center', 'center', 'flex-start', 'flex-start']
        },
        form: {
            maxWidth: '545px',
            padding: ['24px 16px', '24px 16px', '32px', '32px'],
            bg: 'white',
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: 'borderGray'
        },
        number: {
            width: '25px',
            height: '25px',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            bg: 'black',
            color: 'white',
            borderRadius: '50%',
            mb: '8px'
        },
        faqContainer: {
            padding: ['56px 10px', '56px 10px', '56px 40px', '56px 40px'],
            backgroundColor: 'whiteSmoke',
            borderStyle: 'solid',
            borderWidth: '1px 0',
            borderColor: 'borderGray'
        },
        error: {
            color: 'red',
            fontSize: '11px',
            mt: 8
        },
        checkoutInfo: {
            fontSize: '11px',
            mt: 8,
            color: 'darkGray'
        },
        cardInfos: {
            padding: '16px',
            backgroundColor: 'lightBeige',
            borderColor: 'lightBeige',
            mt: 8
        },
        applied: {
            color: 'green',
            textStyle: 'bodyXSmall2',
            textTransform: 'uppercase',
            mr: 14
        }
    }
}
